/**
 * Deli specialties data
 * Represents specialty items and sides available at the deli
 */

const deliSpecialties = [
  {
    id: 1,
    name: "Kosher/Old Dill Pickles",
    category: "specialties"
  },
  {
    id: 2,
    name: "New Dill Pickles",
    category: "specialties"
  },
  {
    id: 3,
    name: "Stuffed Cabbage",
    category: "specialties"
  },
  {
    id: 4,
    name: "Blintz",
    category: "specialties"
  },
  {
    id: 5,
    name: "Knish",
    category: "specialties"
  },
  {
    id: 6,
    name: "Vienna Beef Sticks",
    category: "specialties"
  },
  {
    id: 7,
    name: "Potato Latkes",
    category: "specialties"
  },
  {
    id: 8,
    name: "Creamed Herring",
    category: "specialties"
  },
  {
    id: 9,
    name: "Vegetarian Baked Beans",
    category: "specialties"
  },
  {
    id: 10,
    name: "Sweet Relish",
    category: "specialties"
  }
];

module.exports = deliSpecialties;